import React, { useEffect, useRef, useState } from 'react'
import CRMLayout from '../../../../../../layout/components/CRMLayout'
import LeadForm from '../components/LeadForm';
import leadServices from '../leadServices';
import { CircularProgress } from '@mui/material';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Add, DoubleArrow, OpenInNew } from '@mui/icons-material';
import { useFilteredLead } from '../hook/useFilteredLead';
import LeadInfo from '../components/LeadInfo';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import LeadDetailsView from '../components/LeadDetailsView';
import { Link } from 'react-router-dom';


const CellActions = (props) =>{
    return(
        <>
            <button className='btn btn-outline-primary p-0' onClick={()=>props.setLeadDetails(props.data)}><OpenInNew/></button>
        </>
    )
}


function LeadListPage() {

    const [loading,setLoadingStatus] = useState(false)
    const [leadList,setLeadList] = useState();
    const {getMasterLabel} = useAppData();
    const [leadDetails,setLeadDetails] = useState(null);

    const [isarchivedList,setIsArchivedList] = useState(false)



    const getLeadList = () =>{
        setLoadingStatus(true);
        leadServices.getList().then(res=>{
            setLeadList(res.data);
            setIsArchivedList(false);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getArchivedList = () =>{
        setLoadingStatus(true);
        leadServices.getArchivedList().then(res=>{
            setLeadList(res.data);
            setIsArchivedList(true);
        }).catch(error=>{
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getLeadList();
    },[])


    const gridRef = useRef();


    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
      });
    
    
    const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
        let _columnDefs = [
            {field:"id",headerName: "ID"},
            {field:"businessName",headerName: "Company",width:150},
            {field:"contactPhone1",headerName: "Phone"},
            {field:"created_at",headerName: "Created On",width:150},
            {field:"updated_at",headerName: "Last Updated on",width:150},

            {headerName:"Action", 
                cellRenderer: CellActions,
                cellRendererParams: {
                    setLeadDetails:setLeadDetails
                },
            },   
        ];
        setColumnDef(_columnDefs);
    }


     const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
      };
    
      useEffect(()=>{    
        prepairColumnDef();
    },[]);
    

    return (
        <CRMLayout>
            <div className='row mb-2'>
                <div className='col-md-6'><LeadForm callBack={getLeadList} /></div>
                <div className='col-md-6'>
                    <Link to={"/lead/dashboard"} className='btn btn-outline-primary me-2'>Dashboard View</Link>
                    {isarchivedList ?
                        <button className='btn btn-outline-primary' onClick={getLeadList}>Show New Lead</button>
                        :
                        <button className='btn btn-outline-danger' onClick={getArchivedList}>Show Archived</button>
                    }
                    
                </div>
            </div>
            {loading && <div className='mt-5'><CircularProgress /></div>}
            {!loading &&    
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="ag-theme-alpine" style={{height: 550}}>
                          <AgGridReact
                            ref={gridRef}
                            rowData={leadList}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                          />
                        </div>
                    </div>
                </div>
            }
            <LeadDetailsView
                leadDetails={leadDetails} 
                setLeadDetails={setLeadDetails} 
                callBack={getLeadList} 
            />
        </CRMLayout>
    )
}

export default LeadListPage